var $ = require('jquery')

$(function () {
  $('.charBox03__search-colcontents--search-category--all-open').on('click', function () {
    $('.charBox03__search-colcontents--search-category--list-category').toggle('fast', alertFunc)
  })
  function alertFunc () {
    if ($(this).css('display') == 'block') {
      $('.charBox03__search-colcontents--search-category--all-open').text('閉じる')
    } else {
      $('.charBox03__search-colcontents--search-category--all-open').text('すべて表示する')
    }
  }
})
